import React from "react";
import BRB from "../assets/rosoftsavvy.png";
export default function Logo() {
  return <img src={BRB} alt='BRB Logo' width={30} height={"auto"} />;
}
